import React, { useCallback, useEffect } from "react";
import CentsLogo from "../../cents/CentsLogo";
import { CentsPalette } from "../../../utils/colors";
import { LoginForm } from "./LoginForm";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const Login: React.FC = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const currentCharityId = useSelector((state: RootState) => state.auth.currentCharityId)

  const onSuccess = useCallback(
    () => {
      if (!currentCharityId) return navigate('/charity')
    },
    [navigate, currentCharityId],
  )

  // TODO: Centralized logic for redirecting to the correct page
  useEffect(() => {
    if (isAuthenticated) return navigate('/')
  }, [])

  return (
    <div className="h-fit w-[300px] md:w-[400px] flex flex-col justify-between items-center gap-10 p-5 md:p-10 bg-cents-white text-sm rounded-2xl">
      <CentsLogo height={20} color={CentsPalette.cents_purple} />
      <div className="flex flex-col items-center">
        <p className="text-base">Tap to Donate</p>
        <h2 className="font-medium text-2xl">Charity Portal</h2>
      </div>
      <LoginForm onSuccess={onSuccess} />
    </div>
  )
}

export default Login